// Placeholder Read more copy by consent code, until the detailed statement
// source (landing_page_url markdown) is decided.

export type ConsentDetail = {
  intro: string;
  sections: Array<{ heading: string; paragraphs: string[] }>;
};

export const CONSENT_DETAILS: Record<string, ConsentDetail> = {
  ANALYTICS: {
    intro:
      "We seek your consent to collect and process information about your interactions with our website to understand how visitors use our services and improve the overall shopping experience.",
    sections: [
      {
        heading: "Information we may collect",
        paragraphs: [
          "This may include information about the pages you visit, products you view, time spent on different sections of the website, clicks, navigation patterns, interactions with website features, and information about your device or browser. Cookies, pixels, and similar tracking technologies may be used to collect this information.",
        ],
      },
      {
        heading: "How we use this information",
        paragraphs: [
          "We use this information to analyse website traffic, understand shopper behaviour, identify areas for improvement, monitor website performance, troubleshoot technical issues, and evaluate the effectiveness of website features. These insights help us make the website more useful, reliable, and easier to navigate.",
        ],
      },
      {
        heading: "Sharing with third parties",
        paragraphs: [
          "Where necessary, relevant information may be shared with analytics providers and other service providers who help us measure and analyse website usage. Such providers may process this information on our behalf for the purposes described above.",
          "You may choose whether to provide this consent. If you decline, certain analytics and tracking activities that rely on your consent may not take place. You can change your preferences or withdraw your consent at any time through the available consent settings.",
        ],
      },
    ],
  },
  ADVERTISING: {
    intro:
      "We seek your consent to use relevant information about your interactions with our website to deliver advertisements and promotional content that may be more relevant to your interests.",
    sections: [
      {
        heading: "Information we may collect and use",
        paragraphs: [
          "This may include products you have viewed, categories you have explored, your interactions with promotional offers, browsing activity, and information about your engagement with advertisements. Cookies, pixels, and similar technologies may be used to understand these interactions and support advertising activities.",
        ],
      },
      {
        heading: "How we use this information",
        paragraphs: [
          "We may use this information to show you relevant advertisements, remind you about products you have previously viewed, communicate offers that may interest you, measure the performance of advertising campaigns, and understand whether advertisements lead to visits or purchases. This may include retargeting, where advertisements for products or services you have previously interacted with are shown to you on other websites, applications, or digital platforms.",
        ],
      },
      {
        heading: "Sharing with advertising partners",
        paragraphs: [
          "For these purposes, relevant information may be shared with third-party advertising networks, marketing partners, and service providers that support campaign delivery, audience measurement, and advertising performance analysis. These third parties may process the information in accordance with their applicable privacy policies and terms.",
          "You may choose whether to provide this consent. If you decline, you may still see advertisements, but advertising activities that rely on this consent may be limited. You can change your preferences or withdraw your consent at any time through the available consent settings.",
        ],
      },
    ],
  },
  FUNCTIONAL: {
    intro:
      "We seek your consent to collect and process information about your shopping activity and preferences to provide a more relevant, convenient, and personalized experience on our website.",
    sections: [
      {
        heading: "Information we may collect and use",
        paragraphs: [
          "This may include products you view, categories you browse, items you add to your cart or wishlist, your interactions with product recommendations, preferences you indicate, and your engagement with website features. Where applicable, information collected through cookies and similar technologies may also be used to support personalization.",
        ],
      },
      {
        heading: "How we use this information",
        paragraphs: [
          "We may use this information to recommend products that are relevant to your interests, display personalized offers, remember certain preferences, provide relevant product suggestions, and tailor elements of the shopping experience based on your interactions. For example, we may recommend products similar to those you have viewed or highlight items that may complement products in your cart.",
        ],
      },
      {
        heading: "Sharing and processing",
        paragraphs: [
          "Relevant information may be processed by us and shared with service providers that support website functionality, product recommendations, personalization, and related services. Such processing will be undertaken for the purposes described above and subject to applicable privacy requirements.",
          "You may choose whether to provide this consent. If you decline, certain personalized features may be unavailable or may operate using only information that can be processed without this consent. You can change your preferences or withdraw your consent at any time through the available consent settings.",
        ],
      },
    ],
  },
};
